<template>
  <div
    class="login-wrapper"
    :style="
      !isMobile
        ? { 'background-image': 'url(' + url + background.desktop + ')' }
        : ''
    "
    :class="isMobile ? 'mobile' : ''"
  >
    <div v-if="!isMobile" class="title-wrapper">
      <span class="title">{{ background.title }}</span>
      <span class="subtitle">{{ background.subtitle }}</span>
    </div>
    <p class="description" v-if="!isMobile">
      {{ background.description }}
    </p>
    <div
      v-if="isMobile"
      class="bg-wrapper"
      :style="{ 'background-image': 'url(' + url + background.mobile + ')' }"
    >
      <div class="title">
        <h2>{{ background.title }}</h2>
        <span class="text-dotted">{{ background.subtitle }}</span>
      </div>
    </div>
    <Login />
  </div>
</template>

<script>
import Login from "@/views/Login";
import { mapGetters } from "vuex";
import { gsap } from "gsap";

export default {
  name: "Login-Layout",
  components: {
    Login,
  },
  data() {
    return {
      url: process.env.VUE_APP_BACKEND,
      cache: [],
    };
  },
  computed: {
    ...mapGetters({ background: "getBackground" }),
  },
  mounted() {
    this.startAnimation();
  },
  methods: {
    startAnimation() {
      gsap.from(".login-wrapper", {
        opacity: 0,
        duration: 1,
      });
    },
  },
};
</script>

<style lang="scss">
.login-wrapper {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-position: center center;
  .title-wrapper {
    margin-bottom: $space * 3;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-bottom: 2px solid white;
    position: absolute;
    top: 10%;
    .title {
      font-size: 4rem;
    }
    .subtitle {
      font-size: 2rem;
    }

    .title {
      font-size: 2.8rem;
      font-weight: bold;
      text-transform: uppercase;
      font-family: "Black Quality";
    }
    .subtitle {
      font-size: 1.5rem;
      margin-bottom: $space;
      text-transform: uppercase;
      font-family: "Black Quality";
    }

    @media screen and #{$mq-xlarge} {
      .title {
        font-size: 4rem;
      }
      .subtitle {
        font-size: 2rem;
      }
    }
  }
  .description {
    position: absolute;
    width: 300px;
    left: 100px;
    color: white;
    font-size: 1.2rem;

    &:after {
      content: "";
      position: absolute;
      top: -10px;
      left: 0;
      border-radius: $space;
      height: 5px;
      width: 100px;
      background-color: white;
    }

    @media screen and #{$mq-xlarge} {
      width: 400px;
      left: 200px;
    }
  }
}
.mobile {
  display: flex;
  flex-direction: column;
  background-color: $primary-color;
  justify-content: flex-start;
  .bg-wrapper {
    display: flex;
    align-items: flex-start;
    position: relative;
    overflow: hidden;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    height: 70%;
    width: 100%;
    background-size: cover;
    background-position: center center;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: transparentize($color: black, $amount: 0.5);
      border-bottom: 15px solid darken($bg-color, 10);
      border-bottom-left-radius: 25px;
      border-bottom-right-radius: 25px;
    }
    .title {
      position: absolute;
      font-family: "Black Quality";
      z-index: 20;
      top: $space * 5;
      left: $space * 2;
      right: $space * 2;
      font-size: 1.5rem;
      text-transform: uppercase;
      > * {
        color: white;
      }
      span {
        font-size: 0.87rem;
      }
    }
  }
  .page {
    position: absolute;
    bottom: $space * 2;
    max-width: 90%;
    background-color: white;
    border-radius: $space;
  }
}
</style>
